<template>
    <div class="section main-sect">
        
        <div class="has-text-centered">
            <p><b>Monto: </b> {{payment.amountUy}}</p>
        </div>

        <hr>

        <OrderStatusMessage
            :order="order"
            :payment="payment"
        />

        <MPStatus
            v-if="payment.method == 'mp'"
            :payment="payment"
        />


    </div>
</template>

<script>
import { getHandler, postHandler } from '../../../services/http'
import PaymentForm from "./components/PaymentForm.vue"
import OrderStatusMessage from "./components/OrderStatusMessage.vue"
import MPStatus from "./components/MPStatus.vue"

export default {
    components:{
        PaymentForm,
        OrderStatusMessage,
        MPStatus
    },
    props:{
        orderPayUrl:{
            type:String,
            default:""
        },
        mpChannel:{
            type:String,
            default:""
        },
        cashChannel:{
            type:String,
            default:""
        },
        transferChannel:{
            type:String,
            default:""
        },
        paypalChannel:{
            type:String,
            default:""
        },
        mpPubKey:{
            type:String,
            default:""
        },
        channelList:{
            type:String,
            default:""
        },
        mpMinOrder:{
            type:String,
            default:""
        },
        ppMinOrder:{
            type:String,
            default:""
        },
        usdReports:{
            type:String,
            default:""
        },
        
    },
    data(){
        return{
            order:{},
            payment:{},
            channels:[],
            paymentResp:{}
        }
    },
    computed:{
        usdReportsBool(){
            return this.usdReports == "True"
        },
        mpBool(){
            return this.mpChannel == "True"
        },
        cashBool(){
            return this.cashChannel == "True"
        },
        paypalBool(){
            return this.paypalChannel == "True"
        },
        transferBool(){
            return this.transferChannel == "True"
        }
    },
    methods:{
        async fetchOrderAndPayment(){
            var response = await getHandler(this.orderPayUrl, {error:false, success:false})
            this.order = response.order
            this.payment = response.payment
            console.log(this.order)
            console.log(this.payment)
        },
        async fetchChannels(){
            this.channels = await getHandler(this.channelList, {error:false, success:false})
        },
        updateData(data){
            this.order = data.order
            this.payment = data.payment
            this.paymentResp.status = data.status,
            this.paymentResp.statusDetail = data.statusDetail
        }
    },
    created(){
        this.fetchOrderAndPayment()
        this.fetchChannels()
    }
}
</script>

<style lang="scss" scoped>
.is-custom{
    background:var(--primary);
    color:var(--text-color);
}

.main-sect{
    @media(min-width: 1023px){
        margin-top:45px;
    }
}

</style>